export const TableColumnsAree = ['Id', 'Descrizione', 'Progressivo', 'Codice area', 'Stato', 'Azioni'];
